import { useEffect, useImperativeHandle, useState } from "react";

import SelectCoin from "./SelectCoin";
import { getCoinBalance } from "../../libs/aptos_sdk";
import { useAppSelector } from "../../store/hooks";
import Input from "../Common/Input";

type Props = {
  changeAmount: Function;
  changeCoin: Function;
  onRef: any;
  inCoin?: string;
};

export default function SwapInCard(props: Props) {
  const { changeAmount, changeCoin, inCoin } = props;
  const [selectBalance, setSelectBalance] = useState(0);
  const accountAddresses = useAppSelector(
    (state: any) => state.wallet.accountAddress
  );
  const [amount, setAmount] = useState("");

  useImperativeHandle(props.onRef, () => {
    return {
      setAmount,
      balance: selectBalance,
    };
  });

  useEffect(() => {
    const get = () => {
      getCoinBalance(accountAddresses, inCoin!).then((amount) => {
        if (amount) setSelectBalance(Number(amount));
      });
    };
    get();
    const timer = setInterval(get, 15000);

    return () => {
      clearInterval(timer);
    };
  }, [accountAddresses, changeCoin, inCoin]);

  const handleChangeInputToken = async (input: any) => {
    changeCoin(input.address);
  };

  const handleChangeAmount = (input: any) => {
    changeAmount(input.target.value);
    setAmount(input.target.value);
  };

  return (
    <div className="flex items-start justify-between rounded-xl bg-primary-100 gap-2 p-4">
      <Input
        type="number"
        placeholder="0.00"
        value={amount}
        onChange={handleChangeAmount}
      />
      <div className="flex flex-end items-center shrink-0">
        <SelectCoin
          selectedCoin={inCoin}
          onChange={handleChangeInputToken}
          balance={selectBalance}
        />
      </div>
    </div>
  );
}
